import { createContext } from "preact";

const CalcTypeContext = createContext<{
  type: "flat" | "house" | "business";
  setType: (type: "flat" | "house" | "business") => void;
  isCommon: boolean;
}>({
  type: "flat",
  setType: () => {},
  isCommon: false
});
CalcTypeContext.displayName = "CalcTypeContext";

export default CalcTypeContext;
